import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sidebar, Menu, MenuItem, SubMenu, useProSidebar } from 'react-pro-sidebar';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import Drawer from '@material-ui/core/Drawer';
import MenuRounded from '@material-ui/icons/MenuRounded';
import { AssignmentOutlined } from '@material-ui/icons';
import ExitToAppOutlined from '@material-ui/icons/ExitToAppOutlined';
import ReorderOutlined from '@material-ui/icons/ReorderOutlined';
import ShopOutlined from '@material-ui/icons/ShopOutlined';
import GamesOutlined from '@material-ui/icons/GamesOutlined';
import ViewDayOutlined from '@material-ui/icons/ViewDayOutlined';
import SubscriptionsOutlined from '@material-ui/icons/SubscriptionsOutlined';
import CopyrightOutlined from '@material-ui/icons/CopyrightOutlined';
import ListAltOutlined from '@material-ui/icons/ListAltOutlined';
import CompareOutlined from '@material-ui/icons/CompareOutlined';
import ContactMailOutlined from '@material-ui/icons/ContactMailOutlined';
import PagesOutlined from '@material-ui/icons/PagesOutlined';
import SupervisedUserCircleOutlined from '@material-ui/icons/SupervisedUserCircleOutlined';
import SearchOutlined from '@material-ui/icons/SearchOutlined';
import PublicOutlined from '@material-ui/icons/PublicOutlined';
import AdjustOutlined from '@material-ui/icons/AdjustOutlined';
import AssistantOutlined from '@material-ui/icons/AssistantOutlined';
import AccountTreeOutlined from '@material-ui/icons/AccountTreeOutlined';
import AccountBoxOutlined from '@material-ui/icons/AccountBoxOutlined';
import APIService from '../../service/APIService';
import { makeStyles } from '../../Material-UI/import';
import { useAppContext, useSbar } from '../../store/context';
import './NavBar.css';

const useStyles = makeStyles((theme) => ({
  body: {
    margin: 0,
    fontFamily: '"Figtree", -apple-system, BlinkMacSystemFont, "Segoe UI", "Figtree", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    height: '900vh',
    background: '#ffffff',
    fontSize: '24px',
  },
  app: {
    background: '#a8d5e5',
    height: '900vh',
  },
  logo: {
    margin: theme.spacing(2.5),
    width: '40px',
  },
  textStyle: {
    color: theme.palette.textPrimary.main,
    fontWeight: '500',
  },
  logoDiv: {
    display: 'flex',
    justifyContent: 'center',
  },
  container: {
    overflow: 'auto',
    width: '100%',
    height: '10000px',
    marginLeft: '0px',
  },
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'stretch',
  },
  h1: {
    color: '#165a72',
    margin: '50px auto',
    fontSize: '40px',
  },
  link: {
    fontWeight: '500',
    color: '#165a72',
  },
  myresume: {
    color: '#000000',
  },
  ats: {
    color: '#000000',
  },
  search: {
    color: '#000000',
  },
  track: {
    color: '#000000',
  },
  profile: {
    color: '#000000',
  },
  strt: {
    color: '#000000',
  },
  menu1: {
    marginBottom: '40px',
    marginTop: '20px',
  },
  h2: {
    color: '#165a72',
  },
}));

const width = window.innerWidth;

const NavBar = (props) => {
  const { state } = useAppContext();
  const { email, name, premium } = state.user;
  const [steps, setSteps] = useState(1);
  const [help, setHelp] = useState(false);
  const tSbar = useSbar();
  const { collapseSidebar } = useProSidebar();
  const classes = useStyles();
  const { children } = props;
  const { pathname: currentPath } = useLocation();

  const toggle = () => {
    state.sbar ? tSbar(false) : tSbar(true);
    if (!state.sbar) collapseSidebar();
  };

  const reloadlink = (lnk) => {
    const resolved = `/${lnk}`;
    if (currentPath.startsWith(resolved)) {
      document.location = `/track${resolved}`;
    }
  };

  const logout = () => {
    APIService.logout()
      .then(() => {
        document.location = '/track/login';
      })
      // eslint-disable-next-line no-console
      .catch(console.log);
  };

  useEffect(() => {
    if (state.sbar) collapseSidebar();
  }, [state.sbar]);

  useEffect(() => {
    if (width < 768) collapseSidebar();
  }, []);

  useEffect(() => {
    sessionStorage.setItem('premium', `${premium}`);
    sessionStorage.setItem('name', `${name}`);
    sessionStorage.setItem('email', `${email}`);
    localStorage.setItem('menuguide', 'true');
  }, []);

  return (
    <div style={{ display: 'flex', height: 'auto' }}>
      <Drawer open={help} anchor="right" onClose={() => setHelp(false)}>
        <div style={{ width: 1000 }}>
          <iframe src="/shop/" width="1000px" height="1000px" title="Help panel" />
        </div>
      </Drawer>
      <Sidebar className="app">
        <Menu>
          <MenuItem
            className="menu1"
            icon={<MenuRounded onClick={() => { toggle(); }} />}
          >
            <h2>MyJobAide</h2>
          </MenuItem>
          <MenuItem component={<Link to="/summary" className="link" />} onClick={() => { reloadlink('summary'); }} icon={<DashboardOutlinedIcon />}> Dashboard </MenuItem>
          <MenuItem className="myresume" active={currentPath === '/self' || currentPath.startsWith('/oneloader')} onClick={() => { reloadlink('self'); }} component={<Link to="/self" className="link" />} icon={<AssistantOutlined />}> ResumeÃ¡Â´Â¹ÃŠÂ¸Ã¡Â´Â¶Ã¡Âµâ€™Ã¡Âµâ€¡Ã¡Â´Â¬Ã¡Â¶Â¦Ã¡ÂµË†Ã¡Âµâ€° </MenuItem>
          <SubMenu className="track" label="ÃªÂ­ÂºÃªÂ­Â²ÃªÂ®ÂªÃ¡Â´Â¹ÃŠÂ¸Ã¡Â´Â¶Ã¡Âµâ€™Ã¡Âµâ€¡Ã¡Â´Â¬Ã¡Â¶Â¦Ã¡ÂµË†Ã¡Âµâ€°" defaultOpen={currentPath.startsWith('/dashboard') || currentPath.startsWith('/sumdash') || currentPath.startsWith('/application') || currentPath.startsWith('/analyzeloader')} icon={<GamesOutlined />}>
            <MenuItem component={<Link to="/dashboard" className="link" />} onClick={() => { reloadlink('dashboard'); }} icon={<ReorderOutlined />}> Board </MenuItem>
            <MenuItem component={<Link to="/sumdash" className="link" />} onClick={() => { reloadlink('sumdash'); }} icon={<ListAltOutlined />}> List View </MenuItem>
            <MenuItem component={<Link to="/analyzeloader" className="link" />} onClick={() => { reloadlink('analyzeloader'); }} icon={<AccountTreeOutlined />}>Analyzer</MenuItem>
          </SubMenu>
          <SubMenu className="strt" label="Resume Center" defaultOpen={currentPath.startsWith('/advsearchloader') || currentPath.startsWith('/apploader') || currentPath.startsWith('/advloader')} icon={<AssignmentOutlined />}>
            <MenuItem active={currentPath.startsWith('/apploader')} onClick={() => { reloadlink('apploader'); }} component={<Link to="/apploader" className="link" />} icon={<AssignmentOutlined />}>Power builder</MenuItem>
            <MenuItem active={currentPath.startsWith('/advloader')} onClick={() => { reloadlink('advloader'); }} component={<Link to="/advloader" className="link" />} icon={<PagesOutlined />}>Resume Builder</MenuItem>
            <MenuItem active={currentPath.startsWith('/advsearchloader')} onClick={() => { reloadlink('advsearchloader'); }} component={<Link to="/advsearchloader" className="link" />} icon={<SupervisedUserCircleOutlined />}>ChatGPTÃ¡Â´Â¿Ã¡Âµâ€°Ã¡Âµâ€ºÃ¡Â¶Â¦Ã¡Âµâ€°ÃŠÂ·</MenuItem>
          </SubMenu>
          <SubMenu className="search" defaultOpen={currentPath.startsWith('/searchloader') || currentPath.startsWith('/latestloader')} label="Search and apply" icon={<SearchOutlined />}>
            <MenuItem active={currentPath === '/latestloader'} onClick={() => { reloadlink('latestloader'); }} component={<Link to="/latestloader" className="link" />} icon={<SearchOutlined />}>SearchÃ¡Â´Â¹ÃŠÂ¸Ã¡Â´Â¶Ã¡Âµâ€™Ã¡Âµâ€¡Ã¡Â´Â¬Ã¡Â¶Â¦Ã¡ÂµË†Ã¡Âµâ€°</MenuItem>
            <MenuItem active={currentPath === '/searchloader'} onClick={() => { reloadlink('searchloader'); }} component={<Link to="/searchloader" className="link" />} icon={<SearchOutlined />}>Traditional Search</MenuItem>
          </SubMenu>
          <MenuItem component={<Link to="/jobmatch" className="link" />} onClick={() => { reloadlink('jobmatch'); }} icon={<CompareOutlined />}>Matcher</MenuItem>
          <SubMenu className="profile" defaultOpen={currentPath.startsWith('/oneloader') || currentPath.startsWith('/interview') || currentPath.startsWith('/self') || currentPath.startsWith('/todo')} label="ProfileÃ¡Â´Â¹ÃŠÂ¸Ã¡Â´Â¶Ã¡Âµâ€™Ã¡Âµâ€¡Ã¡Â´Â¬Ã¡Â¶Â¦Ã¡ÂµË†Ã¡Âµâ€°" icon={<PublicOutlined />}>
            <MenuItem active={currentPath === '/interview'} onClick={() => { reloadlink('interview'); }} component={<Link to="/interview" className="link" />} icon={<PublicOutlined />}> InterviewÃ¡Â´Â¹ÃŠÂ¸Ã¡Â´Â¶Ã¡Âµâ€™Ã¡Âµâ€¡Ã¡Â´Â¬Ã¡Â¶Â¦Ã¡ÂµË†Ã¡Âµâ€° </MenuItem>
            <MenuItem active={currentPath === '/todo'} onClick={() => { reloadlink('todo'); }} component={<Link to="/todo" className="link" />} icon={<ViewDayOutlined />}> Todo List </MenuItem>
          </SubMenu>
          <SubMenu className="profile" defaultOpen={currentPath.startsWith('/account') || currentPath.startsWith('/price') || currentPath.startsWith('/shopanalyze')} label="Settings" icon={<SettingsOutlinedIcon />}>
            <MenuItem active={currentPath === '/account'} onClick={() => { reloadlink('account'); }} component={<Link to="/account" className="link" />} icon={<PublicOutlined />}> Account </MenuItem>
            <MenuItem active={currentPath === '/price'} onClick={() => { reloadlink('price'); }} component={<Link to="/price" className="link" />} icon={<SubscriptionsOutlined />}> Subscription </MenuItem>
            <MenuItem active={currentPath === '/shopanalyze'} component={<Link to="/shopanalyze" className="link" />} onClick={() => { reloadlink('shopanalyze'); }} icon={<ShopOutlined />}> Premium tools </MenuItem>
            <MenuItem icon={<ContactMailOutlined />} onClick={() => { document.location.href = 'https://www.myjobaide.com/contact.html'; }}> Contact </MenuItem>
          </SubMenu>
          <MenuItem active={currentPath === '/linkedin' || currentPath.startsWith('/linkedinloader')} onClick={() => { reloadlink('linkedin'); }} component={<Link to="/linkedin" className="link" />} icon={<AdjustOutlined />}>LinkedIn Profile</MenuItem>
          <MenuItem onClick={logout} icon={<ExitToAppOutlined />}> Logout </MenuItem>
          <MenuItem disabled />
          <MenuItem disabled />
          <MenuItem icon={<img width="40px" height="40px" src="menuguide.png" alt="" />} onClick={() => { setSteps(1); }}> &nbsp;<b>Launch Tour</b></MenuItem>
          <MenuItem icon={<img width="40px" height="40px" src="bot.png" alt="" />} onClick={() => window.open('https://www.myjobaide.com/shop')}>&nbsp;<b>May I help?</b></MenuItem>
          <MenuItem disabled icon={<AccountBoxOutlined />}>
            <h5>{state.user.name}</h5>
          </MenuItem>
          <MenuItem disabled icon={<CopyrightOutlined />}>
            <h5>2024 MyJobAide LLC</h5>
          </MenuItem>
        </Menu>
      </Sidebar>
      <div className={classes.container}>
        {children}
      </div>
    </div>
  );
};

export default NavBar;
